import React from 'react';

import { uiConstants } from '../../constants';
import { useAnalytics } from '../../helpers/analytics.helper';
import HKEXNewsTimeLink from '../../modules/Insight/CCASS/HKEXNewsTimeLink';
import { Analytics } from '../../shared/types';
import { ReactTable } from '../../types';

const HKNewsCell: React.FC<ReactTable.CellProps> = ({
  dispatch,
  row: {
    isExpanded,
    index,
    original: { stockCode, news },
  },
  cell: { value },
}) => {
  const exclusivelyToggleExpanded = (index, isExpanded) =>
    dispatch({
      type: 'setExpanded',
      expanded: { [index]: isExpanded },
    });
  const [queue] = useAnalytics();

  return (
    <div>
      {value ? (
        <HKEXNewsTimeLink
          news={news}
          onClick={() => {
            exclusivelyToggleExpanded(
              index,
              isExpanded === uiConstants.MODE_CCASS_NEWS
                ? 0
                : uiConstants.MODE_CCASS_NEWS
            );
            if (isExpanded !== uiConstants.MODE_CCASS_NEWS) {
              queue(Analytics.ActionEnum.ClickNewsList, stockCode);
            }
          }}
        />
      ) : (
        '-'
      )}
    </div>
  );
};

export default HKNewsCell;
